// ConjugationWrapper.jsx - Enhanced with Study Mode
import { useState } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import { FaLightbulb, FaBook, FaEye, FaEyeSlash } from "react-icons/fa";
import TenseForm from "../TenseForm";

export default function ConjugationWrapper({
  submitAnswers,
  checkAnswers,
  selectedTenses,
  verbDetails,
  includeTu,
}) {
  const [hintLevel, setHintLevel] = useState(0);

  const handleHintClick = () => {
    // Cycle through hint levels: 0 -> 1 -> 2 -> 3 -> 0
    setHintLevel((prevLevel) => (prevLevel >= 3 ? 0 : prevLevel + 1));
  };

  // Get the button text based on current hint level
  const getHintButtonText = () => {
    switch (hintLevel) {
      case 0:
        return "Show Hint";
      case 1:
        return "More Help";
      case 2:
        return "Study Mode";
      case 3:
        return "Hide Hints";
      default:
        return "Show Hint";
    }
  };

  // Get the appropriate icon for the current hint level
  const getHintIcon = () => {
    switch (hintLevel) {
      case 0:
        return <FaLightbulb />;
      case 1:
        return <FaLightbulb />;
      case 2:
        return <FaBook />;
      case 3:
        return <FaEyeSlash />;
      default:
        return <FaLightbulb />;
    }
  };

  // Determine if we're in study mode
  const isStudyMode = hintLevel === 3;

  return (
    <>
      <form onSubmit={submitAnswers}>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          spacing={5}
        >
          {selectedTenses.map((tense, i) => (
            <Grid key={i} item md={4} sm={6} xs={12}>
              <Card>
                <CardContent>
                  <TenseForm
                    checkAnswers={checkAnswers && !isStudyMode}
                    key={i}
                    tabOffset={6 * (i + 1)}
                    tense={tense}
                    conjugations={verbDetails.conjugations[0]}
                    ptBr={!includeTu}
                    hintLevel={hintLevel}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "center", gap: "16px" }}
          >
            {/* Only show Check Answers button if not in study mode */}
            {!isStudyMode && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                tabIndex={1000}
              >
                {checkAnswers ? "Hide" : "Check"} Answers
              </Button>
            )}

            <Tooltip
              title={
                hintLevel === 0
                  ? "Show letter count and ending"
                  : hintLevel === 1
                  ? "Reveal 75% of the answers"
                  : hintLevel === 2
                  ? "Show complete answers (study mode)"
                  : "Hide all hints"
              }
            >
              <Button
                variant="outlined"
                color={
                  hintLevel > 0
                    ? hintLevel === 3
                      ? "secondary"
                      : "primary"
                    : "default"
                }
                startIcon={getHintIcon()}
                onClick={handleHintClick}
                disabled={checkAnswers && hintLevel < 3}
                tabIndex={1001}
              >
                {getHintButtonText()}
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
